<template>
  <div>
    <el-table :data="priceTable"
              border>
      <el-table-column fixed
                       prop="packageName"
                       label="套餐名称"
                       width="150">
      </el-table-column>
      <el-table-column label="文件类型"
                       width="120">
        <template slot-scope="scope">
          {{scope.row.fileType|fileTypeFilter}}
        </template>

      </el-table-column>
      <el-table-column label="价格"
                       width="120">
        <template slot-scope="scope">
          {{scope.row.price|priceFilter}}
        </template>
      </el-table-column>
      <el-table-column label="报告类型"
                       width="120">
        <template slot-scope="scope">
          {{scope.row.reportType|reportTypeFilter}}
        </template>
      </el-table-column>
      <el-table-column label="状态"
                       width="100">
        <template slot-scope="scope">
          {{scope.row.status|statusFilter}}
        </template>
      </el-table-column>
      <el-table-column prop="limitCount"
                       label="次数"
                       width="120">
      </el-table-column>
      <el-table-column fixed="right"
                       label="操作">
        <template slot-scope="scope">
          <el-button type="text"
                     size="small"
                     @click="editPrice(scope.row)">编辑</el-button>
          <el-button type="text"
                     size="small"
                     @click="delPrice(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="套餐修改"
               :close-on-click-modal='false'
               :visible.sync="editPriceDialogVisible">
      <el-form :model="curRow"
               label-width="200">
        <el-form-item label="套餐名称"
                      label-position="left"
                      label-width="200">
          <el-input v-model="curRow.packageName"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="文件类型">
          <el-select v-model="curRow.fileType"
                     placeholder="文件类型">
            <el-option label="所有"
                       value="ALL"></el-option>
            <el-option label="PDF"
                       value="PDF"></el-option>
            <el-option label="WORD"
                       value="DOC"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="价格"
                      label-width="200">
          <el-input v-model="curRow.price"
                    type="number"
                    autocomplete="off">
            <template slot="append">分</template>
          </el-input>
        </el-form-item>
        <el-form-item label="报告类型">
          <el-select v-model="curRow.reportType"
                     placeholder="文件类型">
            <el-option label="所有"
                       value="ALL"></el-option>
            <el-option label="个股分析"
                       value="SIMPLE"></el-option>
            <el-option label="个股分析简报"
                       value="TINY"></el-option>
            <el-option label="概念报告"
                       value="CONCEPT"></el-option>
            <el-option label="投资组合"
                       value="COMPARE"></el-option>
            <el-option label="财务报告"
                       value="FINANCE"></el-option>
            <el-option label="感知报告"
                       value="UNLISTED"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="次数"
                      label-width="200">
          <el-input v-model="curRow.limitCount"
                    type="number"
                    autocomplete="off">
            <template slot="append">次</template>
          </el-input>
        </el-form-item>
        <el-form-item label="状态"
                      prop="status">
          <el-radio-group v-model="curRow.status">
            <el-radio label="ONSALE">在售</el-radio>
            <el-radio label="OFFSALE">下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="subEditForm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
export default {
  name: 'myReports',
  data: function () {
    return {
      priceTable: [],
      curRow: {},
      editPriceDialogVisible: false
    }
  },
  filters: {

    dateFilter: function (v) {
      return moment(new Date(parseInt(v))).format('YYYY-MM-DD')
    },

    taskStatusFilter: function (v) {
      switch (v) {
        case 'TRUE':
          return '已完成'
        case 'FALSE':
          return '未完成'
        default:
          return v
      }
    },
    priceFilter: function (v) {
      return (parseInt(v) / 100).toFixed(2) + '元'
    },
    reportTypeFilter: function (v) {
      switch (v) {
        case 'FULL':
          return '个股分析（增强版）'
        case 'SIMPLE':
          return '个股分析'
        case 'TINY':
          return '个股分析简报'
        case 'CONCEPT':
          return '概念报告'
        case 'COMPARE':
          return '投资组合'
        case 'FINANCE':
          return '财务报告'
        case 'ALL':
          return '所有类型'
        case 'UNLISTED':
          return '感知报告'

        default:
          return v
      }
    },
    statusFilter: function (v) {
      switch (v) {
        case 'ONSALE':
          return '在售'
        case 'OFFSALE':
          return '下架'
        default:
          return v
      }
    },
    rolesTypeFilter: function (v) {
      switch (v) {
        case 'ADMIN':
          return '管理员'
        case 'NORMAL':
          return '注册用户'
        case 'VIP':
          return 'VIP用户'
        case 'SVIP':
          return '超级VIP'
        default:
          return v
      }
    },
    fileTypeFilter: function (v) {
      switch (v) {
        case 'PDF':
          return 'PDF'
        case 'DOC':
          return 'WORD'
        case 'ALL':
          return '所有'

        default:
          return v
      }
    }
  },
  methods: {
    getPriceList () {
      let _this = this
      axios.get('/api/web/admin/priceList').then(resp => {
        _this.priceTable = resp.data
      })
    },
    subEditForm (row) {
      let _this = this
      axios.post('/api/web/admin/editPrice', this.curRow).then(resp => {
        _this.editPriceDialogVisible = false
        _this.$message({
          message: '修改成功',
          type: 'success'
        })
        _this.getPriceList()
      })
    },
    editPrice (row) {
      this.curRow = row
      this.editPriceDialogVisible = true
    },
    delPrice (row) {
      let _this = this
      this.$confirm('是否删除套餐【' + row.packageName + '】?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.get('/api/web/admin/delPrice?id=' + row.id).then(resp => {
          _this.$message({
            message: '删除成功',
            type: 'success'
          })
          _this.getPriceList()
        })
      })
    }
  },
  components: {

  },
  mounted () {
    this.getPriceList()
  },
  watch: {

  }
}
</script>
<style scope>
.container-fluid {
  background: url("/static/img/courses-header.jpg");
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/price.vue